export enum SurveyType {
  START_UP = 'Start Up',
  INITIAL = 'Initial',
  INVESTIGATION = 'Investigation',
  SECOND_YEAR_SELF = '2nd year self',
  THIRD_YEAR_SELF = '3rd year self',
  RE_SURVEY = 'Re-survey',
  LIFE_SAFETY_CODE = 'Life Safety Code',
  FOLLOW_UP = 'Follow Up Survey',
  RE_ACTIVATION = 'Re-Activation',
  VALIDATION_SURVEY = 'Validation Survey'
}
